import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IntegrationsImportService } from '../integration.import.service';
import { ActivatedRoute } from '@angular/router';
import {
  IntegrationImportError,
  IntegrationImportErrorColumn,
  IntegrationImportErrorResult,
  IntegrationImportErrorsParams,
  Order
} from "../integration-imports.interface";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {GetIntegrationImportErrorsAction} from "../integration-imports.actions";
import {Store} from "@ngrx/store";
import {IState} from "../../../shared/models/state";
import {
  getIntegrationImportErrorsDataSelector,
  getIntegrationImportErrorsParamsSelector
} from "../integration-imports.reducer";
import {Location} from "@angular/common";
import {PageEvent} from "@angular/material/paginator/typings/paginator";
import {Sort} from "@angular/material/sort/typings/sort";

@Component({
  selector: 'cc-integration-import-errors',
  templateUrl: 'integration-import-errors.component.html',
  styleUrls: ['integration-import-errors.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IntegrationImportErrorsComponent implements OnInit {
  public params: IntegrationImportErrorsParams;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions = [10, 20, 100];
  @Input() public dataSource: MatTableDataSource<IntegrationImportError>;
  public total: number;
  displayedColumns: string[] = ['sourceObjectId', 'msisdn', 'reason'];

  public rows: IntegrationImportError[];

  constructor(
    private integrationsImportService: IntegrationsImportService,
    private route: ActivatedRoute,
    private store: Store<IState>,
    public location: Location
  ) {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);
    this.store.select(getIntegrationImportErrorsParamsSelector).subscribe(params => {
      this.params = params;
      if (this.params && this.params.pager) {
        const { limit, page } = this.params.pager || ({} as any);
        this.paginator.pageSize = limit;
        this.paginator.pageIndex = page - 1;
      }
    });

    this.store.select(getIntegrationImportErrorsDataSelector).subscribe((errors: IntegrationImportErrorResult) => {
      this.dataSource.data = errors.data;
      this.total = errors.total;
      this.paginator.length = errors.total;
    });
  }
  
  sortChange($event: Sort) {
    this.store.dispatch(new GetIntegrationImportErrorsAction({
      ...this.params,
      order: $event.direction ? Order[$event.direction.toUpperCase()] : null,
      sortBy: IntegrationImportErrorColumn[$event.active]
    }));
  }

  onPageChange(event: PageEvent) {
    this.params.pager = {
      limit: event.pageSize,
      page: event.pageIndex + 1
    };
    this.store.dispatch(new GetIntegrationImportErrorsAction(this.params));
  }

  back() {
    this.location.back();
  }
}
